<template>
	<v-textarea
		:value="value"
		:label="area.label"
		:maxlength="area.maxlength"
		:disabled="area.disable"
		:no-resize="area.noresize"
		:densse="area.densse"
		:hide-details="area.hideDetail"
		:error-messages="area.errorMessage"
		:counter="area.counter"
		:clearable="area.clearable"
		:persistent-hint="area.persistentHint"
		:prepend-inner-icon="area.prependinnericon"
		:readonly="area.readonly"
		:autofocus="area.autofocus"
		:rules="area.rules"
		:rows="area.rows"
		:outlined="area.outlined"
		:class="area.class"
		:height="area.height"
		:color="area.color ? area.color : $store.state.PointColor1"
		@input="$emit('input', $event)"
	></v-textarea>
</template>

<script>
export default {
	props: {
		value: String,
		area: Object,
	},
}
</script>

<style></style>
